import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H6 = styled.h6`
  font-weight: 600;
  &,
  * {
    font-size: 16px;
    line-height: 24px;
  }

  ${media.tablet`
    &, * {
      font-size: 14px;
      line-height: 24px;
    }
  `}
`

export default H6
